export default __webpack_public_path__ + "static/media/Bridesmaids.801ce5ec.mov";